import React from "react";
import icon from "../../../Assets/Images/Image/footer icon.png";

const Newsletter = () => {
  return (
    <div className="bg-[#FF0000] 2xl:w-[30%] px-8 py-16 text-center ">
      <h2 className="text-[#FFFFFF] text-3xl font-fira font-bold  ">
        Subscribe To our Newsletter
      </h2>
      <p className="text-[#DDE3FD] text-base font-normal  font-roboto mt-2">
        Printer took a galley of type and scrambled to make a type specimen
        book.
      </p>

      <form className="mt-8">
        <input
          type="text"
          required
          placeholder="Full Name"
          className="w-[90%] mx-auto block  py-3 px-5 text-[#6A6D7A] text-base rounded"
        />
        <input
          type="Email"
          required
          placeholder="Email Address"
          className="w-[90%] mt-5 mx-auto block py-3 px-5 text-[#6A6D7A] text-base rounded"
        />

        <button className="flex justify-between mx-auto mt-10 bg-[#E90000] w-[176px] h-[50px] font-normal items-center px-3 text-[#FFFFFF] text-base">
          Subscribe Now <img src={icon} alt="IT Ghar" />{" "}
        </button>
      </form>
    </div>
  );
};

export default Newsletter;
